import { Button } from 'antd';
import styled from 'styled-components';

export const StyledIconButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  border-radius: 50% !important;

  > span {
    font-weight: 600 !important;
  }

  .ant-btn-icon {
    width: 24px;
    height: 24px;

    > img {
      width: 100%;
      height: 100%;
    }
  }
`;
